'use client'
import { useEffect } from 'react'
import { sendHelpEvent } from '@/lib/help/telemetry'

/**
 * Island que emite `article_viewed` al montar. Las páginas /help/[slug] son SSG,
 * así que la vista solo se cuenta cuando un navegador real renderiza el artículo.
 */
export default function ArticleTelemetry({
  slug,
  locale,
}: {
  slug: string
  locale: string
}) {
  useEffect(() => {
    sendHelpEvent({ event: 'article_viewed', article_slug: slug, locale })
  }, [slug, locale])
  return null
}
